module.exports = __webpack_public_path__ + "static/img/top1_i7_nav.97e931d8.png";